// removed by extract-text-webpack-plugin
module.exports = {"nf-view-users":"nf-view-users","nf-view-users__header":"nf-view-users__header","nf-view-users__subheader":"nf-view-users__subheader","nf-view-users__add-user":"nf-view-users__add-user","nf-button--add":"nf-button--add","nf-view-users__content":"nf-view-users__content","nf-view-users__grid":"nf-view-users__grid","view-users-main-container":"view-users-main-container","view-users-header":"view-users-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ViewUsers/ViewUsers.scss
// module id = 5341
// module chunks = 1